<template>
  <!-- 站点信息 -->
  <div>
    <w-table
      v-if="typeName"
      v-loading.body="tableLoading"
      :data-list="companyData"
      :columns="staticData[typeName].columns"
      :bPagination="false"
    >
      <template slot-scope="props" slot="cell">
        <a
          v-if="
            props.column.label === '备案异常' ||
            props.column.label === '未备案车'
          "
          @click="onShowDialog(props)"
          class="num"
          >{{ props.row[props.column.property] }}</a
        >
        <span v-else>{{ props.row[props.column.property] }}</span>
      </template>
    </w-table>
    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="width"
      :isShowFooter="false"
      className="i-dialog"
      @handleCloseRight="handleClose"
      @handleClose="handleClose"
    >
      <template v-slot:content>
        <button class="export" @click="onExportBike">导出</button>
        <w-table
          v-if="columnName"
          :data-list="bikeData"
          :columns="staticData[columnName].columns"
          :bPagination="false"
          :height="525"
        >
          <template slot-scope="props" slot="cell">
            <span v-if="props.column.label === '序号'">{{
              props.index + 1
            }}</span>
            <span v-else>{{ props.row[props.column.property] }}</span>
          </template>
        </w-table>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import WTable from "@/components/Table/index.vue";
import staticData from "./staticData.js";
import Api from "@/api";
import WDialog from "@/components/Model/index.vue";

export default {
  components: {
    WTable,
    WDialog,
  },
  props: ["typeName", "currentData"],
  data() {
    return {
      legality: null,
      brandIds: "",
      width: "50%",
      type: "",
      dialogTitle: "",
      tableLoading: false,
      tableData: null,
      companyData: [],
      bikeData: [],
      columnName: "",
    };
  },
  computed: {
    staticData() {
      return staticData;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    onExportBike() {
      const vm = this;
      const params = {
        selfAreaId: vm.currentData.selfAreaId,
        brandIds: this.brandIds,
      };
      if (this.legality !== null) {
        params.legality = this.legality;
      }
      const loading = vm.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      Api.sitebikeOut(params).then((res) => {
        loading.close();
        vm.$message({
          type: "success",
          message: "数据导出成功！",
        });
        const content = res;
        const blob = new Blob([content]);
        const fileName = "车辆统计.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    handleClose() {
      this.$refs["w-dialog"].onCloseDialog();
    },
    onShowDialog(data) {
      this.dialogTitle = data.row.brandName.slice(0, 2) + data.column.label;
      this.bikeData =
        data.row.list[data.column.property == "warn" ? "warn" : "abnormal"];
      this.columnName = data.column.property;
      this.width = data.column.label == "备案异常" ? "960px" : "420px";
      this.brandIds = data.row.brandId;
      this.legality = data.column.label == "备案异常" ? 2 : 1;
      this.$refs["w-dialog"].onShowDialog();
    },
    initData() {
      const vm = this;
      vm.tableLoading = true;
      Api.getBikeMonitor({ selfAreaId: vm.currentData.selfAreaId }).then(
        (res) => {
          console.log(res, 111);
          if (res.code === 200) {
            vm.companyData = Object.values(res.data).map((val) => {
              return { ...val, ...val.count };
            });
          } else {
            vm.$message.warning(res.message);
          }
          vm.tableLoading = false;
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.num {
  color: #00dada;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
.export {
  margin-bottom: 16px;
  cursor: pointer;
}


</style>
